const TOKEN_KEY = 'numgame_token'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

function apiBase(): string {
  const base = import.meta.env.VITE_API_BASE as string | undefined
  return base?.replace(/\/$/, '') ?? ''
}

function resolveLocale(): string {
  try {
    const lang = localStorage.getItem('numbergame:language')
    if (lang) {
      const parsed = JSON.parse(lang) as string
      if (parsed === 'zh' || parsed === 'en') return parsed
    }
  } catch {
    /* ignore */
  }
  if (typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function apiRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json')
  }
  const token = getToken()
  if (token) headers.set('Authorization', `Bearer ${token}`)
  headers.set('X-Locale', resolveLocale())

  const res = await fetch(`${apiBase()}${path}`, {
    ...options,
    headers,
  })

  if (res.status === 204) return undefined as T

  const data = await res.json().catch(() => ({}))

  if (!res.ok) {
    if (res.status === 401) {
      setToken(null)
    }
    throw new ApiError(
      res.status,
      (data as { code?: string }).code ?? 'UNKNOWN',
      (data as { error?: string }).error ?? res.statusText
    )
  }

  return data as T
}
